












































































































































































































































// ИЗВЕСТНОЕ: IDE (vscode TS server) может показывать ложные ошибки в этом файле:
//   - "Cannot find module '@/graphql/*.gql'" — для .gql нужен type-shim, см. `shims-gql.d.ts`
//     (был удалён в 9e9989a; vue-apollo поставляет свой shim — IDE его не всегда видит).
//   - "A module cannot have multiple default exports" / "historySinceDisplay does not exist"
//     — артефакты vue-property-decorator + ts-server при инкрементальном редактировании.
// Реальный `npx tsc --noEmit` и `npm run lint` показывают 0 ошибок в этом файле.
// Repo-wide TS-config issue, чинить не в этом PR.
import {
  Component, Mixins, Watch,
} from 'vue-property-decorator';
import StorageMixin from '@/mixins/StorageMixin';
import PretensionHttpErrorMixin from '@/mixins/PretensionHttpErrorMixin';
import DateRange from '@/components/common/DateRange.vue';
import PretensionController from '@/controllers/Pretension';
import { PretensionReportParams } from '@/controllers/types';
import GetPlantsHRAndClientListing from '@/graphql/GetPlantsHRAndClientListing.gql';
import { PretensionType } from '@/types/Pretension';
import {
  PretensionReportApiResponse,
  PretensionReportApiRow,
  PretensionReportFilterStatus,
  PretensionReportTableHistoryRow,
  PretensionReportTableRow,
  PretensionReportTotals,
  PRETENSION_REPORT_FILTER_STATUSES,
  CANONICAL_TO_RAW_STATUSES,
  VISIBLE_RAW_STATUSES,
  canonicalStatus,
  formatMoneyRu,
  humanizePretensionStatus,
  mapRowToTableRow,
} from '@/utils/pretensionsReportDisplay';
import {
  ChangedByDisplay,
  displayChangedBy,
} from '@/utils/pretensionStatusHistoryDisplay';
import { buildPretensionsReportWorkbook } from '@/utils/pretensionsReportExcel';
import { validatePeriod } from '@/utils/dateRangeValidation';
import XLSX from 'xlsx';

interface PaginationInfo { total: number; pageFrom: number; pageSize: number }
interface DataTableOptions {
  page: number; itemsPerPage: number;
  sortBy: string[]; sortDesc: boolean[]; multiSort: boolean;
}

@Component({
  components: { DateRange },
  // Дефолт для prop'ы из StorageMixin (Vue prop, не class field).
  // Объявляется здесь, потому что @Prop в наследнике конфликтует с базовым @Prop
  // из миксина (TS2612). `declare` ниже снимает type-warning.
  props: {
    localStoragePrefix: { type: String, default: 'PretensionsReport' },
  },
})
export default class PretensionsReport extends Mixins(StorageMixin, PretensionHttpErrorMixin) {
  declare readonly localStoragePrefix: string;

  static readonly MAX_XLSX_EXPORT_ROWS = 50000;

  static readonly SERVER_PAGINATION_THRESHOLD = 500;

  static readonly TABLE_PAGE_SIZE = 500;

  static readonly XLSX_CHUNK = 999;

  // Whitelist для гидрации selectedStatuses из localStorage (см. parseStoredStringArray).
  // Включает все статусы фильтра отчёта, в т.ч. 'disputed', которого нет
  // во frontend-enum PretensionStatus.
  static readonly ALLOWED_STATUSES = new Set<string>(PRETENSION_REPORT_FILTER_STATUSES);

  // === filter state — class-field hydrate из localStorage (см. §3.5.1) ===
  selectedPlatform: string | null = this.getFromStorage('platform') || null;

  selectedType: PretensionType | null = this.parseStoredType();

  selectedSuppliers: number[] = this.parseStoredNumberArray('suppliers');

  // `parseStoredStringArray` фильтрует значения по ALLOWED_STATUSES — гарантировано
  // выдаёт только валидные коды, поэтому assertion безопасен.
  selectedStatuses: PretensionReportFilterStatus[] = this.parseStoredStringArray(
    'statuses',
    PretensionsReport.ALLOWED_STATUSES,
  ) as PretensionReportFilterStatus[];

  dates: string[] = [];

  // Watcher suppression flag — поднимается перед каскадом изменений фильтров,
  // опускается через nextTick. БЕЗ `_`-префикса: Vue 2 не проксирует `_*` data-поля
  // на instance, что для boolean ещё работает «вопреки» (undefined ≈ false), но
  // консистентность с tableLoadSeq важнее.
  suppressWatchers = false;

  // Гейт: loadReport ждёт справочники, чтобы watcher-фейерверк не выстрелил
  // запросом до того, как справочники подгрузятся (см. ревью #1).
  private dictionariesLoaded = false;

  // === pagination/data state ===
  pageFrom = 0;

  rows: PretensionReportApiRow[] = [];

  totals: PretensionReportTotals | null = null;

  pagination: PaginationInfo | null = null;

  tableOptions: DataTableOptions = {
    page: 1, itemsPerPage: 100, sortBy: [], sortDesc: [], multiSort: false,
  };

  isDataLoading = false;

  // Отдельный флаг — XLSX-экспорт не должен дёргать `:loading` таблицы,
  // и не должен делить состояние с loadReport (см. ревью BC3.1 #1).
  isXlsxLoading = false;

  // Прогресс XLSX-экспорта (страниц завершено / всего страниц).
  xlsxProgress: { current: number; total: number } | null = null;

  // === dictionaries ===
  platforms: Array<{ id: number; name: string }> = [];

  suppliers: Array<{ id: number; legal_name: string; PlantsHR?: Array<{ id: number }> }> = [];

  // Sequence guard от race-condition между параллельными loadReport'ами таблицы +
  // debounce-таймер. ИНИЦИАЛИЗИРУЮТСЯ В created() через Object.defineProperty,
  // чтобы НЕ попадать в Vue's data() (исключить reactive-overhead на 50 инкрементов
  // за XLSX-экспорт). Объявлены через `declare` — TS знает типы, Vue не видит data-поля.
  // ИСТОРИЯ: ранее использовался `_`-префикс (Vue-конвенция non-reactive), но Vue 2
  // НЕ ПРОКСИРУЕТ `_*` data-поля на instance, что приводило к `this._foo = undefined`
  // и NaN-баг'у в seq-guard (см. ревью B5).
  declare tableLoadSeq: number;

  declare loadDebounceTimer: ReturnType<typeof setTimeout> | null;

  // === static configurations ===
  readonly typeOptions = [
    { name: 'Ущерб', value: 'damage' as PretensionType },
    { name: 'Штраф', value: 'fine' as PretensionType },
  ];

  // i18n-помощник как обычный метод — class-field arrow ломается при mock'е $t
  // в jest-окружении (vue-property-decorator + vue-test-utils mocks).
  // Передача в утилиты через inline closure (см. tableRows, statusOptions): closure
  // создаётся при каждом вызове, но Vue computed memoize по reactive deps, не по identity,
  // — лишних пересчётов не возникает.
  protected t(k: string): string { return this.$t(k) as string; }

  // Явная reactivity-зависимость от $i18n.locale: гарантирует пересчёт getter'ов при
  // смене локали (vue-i18n's $t reactive, но компилятор Vue не всегда трекает его как dep —
  // явное чтение убирает неопределённость).
  private get _localeTracker(): string { return (this.$i18n?.locale as string) || 'ru'; }

  // Геттер вместо class field — реактивно пересчитывается при смене локали.
  get statusOptions() {
    void this._localeTracker;
    return PRETENSION_REPORT_FILTER_STATUSES.map((code) => ({
      name: humanizePretensionStatus(code, this.t),
      code,
    }));
  }

  // Чипы «По статусам»: схлопываем сырые статусы в канонические (diadoc_signing_await →
  // signer_signing_await), суммируя count+amount → одна плашка на канонический статус.
  get byStatusGrouped(): Array<{ status: string; count: number; amount: number }> {
    if (!this.totals) return [];
    const grouped = new Map<string, { status: string; count: number; amount: number }>();
    (this.totals.byStatus ?? []).forEach((g) => {
      const canonical = canonicalStatus(g.status);
      const acc = grouped.get(canonical) ?? { status: canonical, count: 0, amount: 0 };
      acc.count += g.count;
      acc.amount += g.amount;
      grouped.set(canonical, acc);
    });
    return Array.from(grouped.values());
  }

  get tableHeaders() {
    void this._localeTracker;
    return [
      { text: 'ID', value: 'id', width: 80 },
      { text: this.t('pretension_report_table_number'), value: 'number', width: 130 },
      { text: this.t('pretension_report_table_type'), value: 'type', width: 90 },
      { text: this.t('Platform'), value: 'platformName' },
      { text: this.t('Supplier'), value: 'supplierLegalName' },
      { text: this.t('pretension_report_table_created'), value: 'createdAtIso', width: 120 },
      { text: this.t('pretension_report_total_amount'), value: '_amount', width: 140 },
      { text: this.t('pretension_report_filter_status'), value: 'currentStatus', width: 180 },
    ];
  }

  get footerProps() {
    return this.isServerPagination
      ? { itemsPerPageOptions: [500], showFirstLastPage: true }
      : { itemsPerPageOptions: [50, 100, 200, 500], showFirstLastPage: true };
  }

  // Мемоизация по reference на `rows`: Vue computed уже кеширует по reactive deps,
  // но здесь мы дополнительно отрезаем пересчёты при сменах НЕ-зависимостей (например,
  // смена локали тоже триггерит пересчёт через _localeTracker — это by-design).
  // Cache invalidates когда меняется reference или локаль.
  // Cache для tableRows — invalidates по reference на rows и по локали.
  // БЕЗ `_`-префикса для консистентности; реактивность Vue этого поля безвредна
  // (объект хранится для memoization, никто на него не подписан).
  tableRowsCache: {
    src: PretensionReportApiRow[];
    locale: string;
    out: PretensionReportTableRow[];
  } | null = null;

  get tableRows(): PretensionReportTableRow[] {
    const locale = this._localeTracker;
    if (this.tableRowsCache
      && this.tableRowsCache.src === this.rows
      && this.tableRowsCache.locale === locale) {
      return this.tableRowsCache.out;
    }
    const out = this.rows.map((r) => mapRowToTableRow(r, this.t));
    this.tableRowsCache = { src: this.rows, locale, out };
    return out;
  }

  get isServerPagination(): boolean {
    return (this.pagination?.total ?? 0) > PretensionsReport.SERVER_PAGINATION_THRESHOLD;
  }

  // Возвращает true когда дат недостаточно для валидации (length !== 2) —
  // это «пока нет данных», а не «валидно». Так задумано, чтобы UI не показывал
  // ошибку до того, как DateRange эмиттит первый @datesChanged. Не путать с
  // «есть валидный период» — для проверки наличия периода используй dates.length === 2.
  get isPeriodValid(): boolean {
    if (!Array.isArray(this.dates) || this.dates.length !== 2) return true;
    return validatePeriod(this.dates[0], this.dates[1]).ok;
  }

  get periodErrorMessage(): string {
    if (!Array.isArray(this.dates) || this.dates.length !== 2) return '';
    const r = validatePeriod(this.dates[0], this.dates[1]);
    return r.ok ? '' : r.message;
  }

  // canDownloadXlsx — single source of truth: «можно скачать» = «нет причины блокировки».
  // Любое новое блокирующее условие добавляется в xlsxBlockedReason — `canDownloadXlsx`
  // обновится автоматически.
  get canDownloadXlsx(): boolean {
    return this.xlsxBlockedReason === null;
  }

  // Причина, по которой XLSX-экспорт сейчас невозможен. null = доступен.
  // Tooltip над disabled-кнопкой использует это сообщение — юзеру сразу видна причина.
  get xlsxBlockedReason(): string | null {
    if (this.isDataLoading) return this.t('pretension_report_loading');
    if (this.isXlsxLoading) return this.t('pretension_report_xlsx_in_progress');
    if (!this.isPeriodValid) return this.periodErrorMessage;
    // Pagination=null означает «отчёт ещё не запрашивался» — отдельный UX-state
    // от «найдено 0 строк», чтобы пользователь понимал, что нужно подождать загрузку.
    if (!this.pagination) return this.t('pretension_report_not_loaded_yet');
    if (this.pagination.total === 0) return this.t('pretension_report_xlsx_empty');
    if (this.pagination.total > PretensionsReport.MAX_XLSX_EXPORT_ROWS) {
      return this.$t('pretension_report_xlsx_too_many', {
        total: this.pagination.total,
        limit: PretensionsReport.MAX_XLSX_EXPORT_ROWS,
      }) as string;
    }
    return null;
  }

  get hasActiveFilters(): boolean {
    return (
      !!this.selectedPlatform || !!this.selectedType
      || this.selectedSuppliers.length > 0 || this.selectedStatuses.length > 0
    );
  }

  get suppliersFilter() {
    if (this.selectedPlatform && Number(this.selectedPlatform)) {
      return this.suppliers.filter((s) => s.PlantsHR?.some((p) => Number(p.id) === Number(this.selectedPlatform)));
    }
    return this.suppliers;
  }

  get xlsxProgressPercent(): number {
    if (!this.xlsxProgress || this.xlsxProgress.total === 0) return 0;
    return Math.min(100, Math.round((this.xlsxProgress.current / this.xlsxProgress.total) * 100));
  }

  get historySinceDisplay(): string | null {
    return process.env.VUE_APP_PRETENSION_HISTORY_SINCE || null;
  }

  changedByDisplay(h: PretensionReportTableHistoryRow): ChangedByDisplay {
    return displayChangedBy(h.changedBy, h.changedAtIso, this.historySinceDisplay);
  }

  // Гидрация массива чисел: каждый элемент пропускается через Number и проверяется
  // на конечность и положительность. Защита от повреждённого localStorage и от
  // устаревших форматов хранения (например, после миграции схемы).
  private parseStoredNumberArray(key: string): number[] {
    try {
      const arr = JSON.parse(this.getFromStorage(key) || '[]');
      if (!Array.isArray(arr)) return [];
      return arr
        .map((v) => Number(v))
        .filter((n) => Number.isFinite(n) && n > 0);
    } catch { return []; }
  }

  // Гидрация массива строк с whitelist'ом — отбрасывает значения, не попадающие
  // в актуальный набор статусов фильтра (защита от устаревших ID после
  // изменения backend-enum'а).
  private parseStoredStringArray(key: string, allowedValues?: ReadonlySet<string>): string[] {
    try {
      const arr = JSON.parse(this.getFromStorage(key) || '[]');
      if (!Array.isArray(arr)) return [];
      const strs = arr.filter((v): v is string => typeof v === 'string' && v.length > 0);
      if (allowedValues) return strs.filter((s) => allowedValues.has(s));
      return strs;
    } catch { return []; }
  }

  // helper для гидрации type — валидируем значение (защита от повреждённого localStorage)
  private parseStoredType(): PretensionType | null {
    const raw = this.getFromStorage('type');
    return (raw === 'damage' || raw === 'fine') ? raw : null;
  }

  // === lifecycle ===
  created() {
    // Регистрируем non-reactive instance-поля. Object.defineProperty создаёт own
    // writable property, перекрывая любой Vue-proxy. См. объявления `declare` выше.
    Object.defineProperty(this, 'tableLoadSeq', {
      value: 0, writable: true, configurable: true, enumerable: false,
    });
    Object.defineProperty(this, 'loadDebounceTimer', {
      value: null, writable: true, configurable: true, enumerable: false,
    });
    const q = this.$route?.query || {};
    if (q.platform) this.selectedPlatform = String(q.platform);
    if (q.type) this.selectedType = q.type as PretensionType;
    if (q.suppliers) {
      this.selectedSuppliers = String(q.suppliers).split(',').filter(Boolean).map(Number);
    }
    if (q.statuses) {
      this.selectedStatuses = String(q.statuses)
        .split(',')
        .filter((s): s is PretensionReportFilterStatus => PretensionsReport.ALLOWED_STATUSES.has(s));
    }
  }

  async beforeMount() {
    await this.loadDictionaries();
    this.dictionariesLoaded = true;
    // Если DateRange уже эмиттил dates (через mounted-hook) до того, как мы загрузили
    // справочники — watcher dates бросил scheduleLoadReport, но он рано вернулся
    // (dictionariesLoaded был false). Сами триггерим повторный fetch.
    if (Array.isArray(this.dates) && this.dates.length === 2 && this.isPeriodValid) {
      this.scheduleLoadReport();
    }
  }

  beforeDestroy() {
    if (this.loadDebounceTimer) clearTimeout(this.loadDebounceTimer);
  }

  // calculateDefaultDates() удалён сознательно: дефолт диапазона дат рассчитывает
  // компонент DateRange (см. components/common/DateRange.vue:setDefaultDates).
  // Родитель не должен дублировать эту логику — иначе на initial mount гонка
  // приводит к 2-3 лишним HTTP-запросам с разными датами (см. ревью BC3.1 #1).
  // clearFilters() полагается на $bus.$emit('clear-filters'), который DateRange ловит
  // и сбрасывает свои даты к дефолту — это и есть единая точка истины.

  async loadDictionaries() {
    try {
      const res = await this.$apollo.query({
        query: GetPlantsHRAndClientListing,
        variables: {},
      });
      this.platforms = res?.data?.getPlantsHRListing?.edges?.map((e: any) => e.node) ?? [];
      this.suppliers = res?.data?.getSupplierListing?.edges?.map((e: any) => e.node) ?? [];
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('loadDictionaries failed', e);
      this.$bus.$emit('notification', 'Не удалось загрузить справочники', 'error');
    }
  }

  buildFilterParams(): PretensionReportParams {
    const params: PretensionReportParams = {
      dateFrom: this.dates[0],
      dateTo: this.dates[1],
      pageFrom: this.pageFrom,
      pageSize: PretensionsReport.TABLE_PAGE_SIZE,
    };
    if (this.selectedType) params.type = this.selectedType as 'damage' | 'fine';
    if (this.selectedPlatform) params.platformId = Number(this.selectedPlatform);
    if (this.selectedSuppliers.length) params.supplierIds = this.selectedSuppliers.map(Number);
    // .slice() — отвязываем snapshot от реактивного массива (ревью BC3.1 #3):
    // если позже кто-то будет мутировать selectedStatuses вместо replace,
    // baseParams в downloadXLSX не уплывёт за ним.
    // statuses всегда шлём (контракт запроса): выбранные канонические раскрываем в сырые;
    // при пустом выборе — полный видимый whitelist (9 кодов), чтобы бэк исключил
    // created/draft_discarded и тоталы/«Всего» считались только по 8 видимым статусам.
    params.statuses = this.selectedStatuses.length
      ? this.selectedStatuses.flatMap((c) => CANONICAL_TO_RAW_STATUSES[c] ?? [c])
      : VISIBLE_RAW_STATUSES.slice();
    return params;
  }

  // Сброс данных в единой точке — DRY, чтобы все error-пути не расходились.
  private resetReportData() {
    this.rows = [];
    this.totals = null;
    this.pagination = null;
  }

  async loadReport() {
    if (!this.isPeriodValid || !this.dictionariesLoaded
      || !Array.isArray(this.dates) || this.dates.length !== 2) return;
    this.tableLoadSeq += 1;
    const mySeq = this.tableLoadSeq;
    this.isDataLoading = true;
    try {
      const response = await PretensionController.report(this.buildFilterParams());
      if (mySeq !== this.tableLoadSeq) return;
      if (response.result[0]) {
        const outcome = this.classifyHttpError(response);
        this.$bus.$emit('notification', outcome.message, outcome.type);
        this.resetReportData();
        return;
      }
      const payload = response.result[1] as PretensionReportApiResponse | null | undefined;
      const rows = Array.isArray(payload?.data?.rows) ? payload!.data.rows : [];
      const totals = payload?.data?.totals ?? null;
      const pagination = payload?.data?.pagination
        ?? (rows.length > 0
          ? { total: rows.length, pageFrom: 0, pageSize: rows.length }
          : null);
      this.rows = rows;
      this.totals = totals;
      this.pagination = pagination;
    } catch (e) {
      if (mySeq !== this.tableLoadSeq) return;
      // eslint-disable-next-line no-console
      console.error('loadReport failed', e);
      this.$bus.$emit('notification', 'Не удалось загрузить отчёт', 'error');
      this.resetReportData();
    } finally {
      if (mySeq === this.tableLoadSeq) this.isDataLoading = false;
    }
  }

  scheduleLoadReport() {
    if (this.loadDebounceTimer) clearTimeout(this.loadDebounceTimer);
    this.loadDebounceTimer = setTimeout(() => this.loadReport(), 50);
  }

  filterChanged() {
    this.pageFrom = 0;
    this.tableOptions.page = 1;
    this.syncQueryParams();
    this.persistFiltersToStorage();
    this.scheduleLoadReport();
  }

  // Сравнение независимо от порядка ключей — JSON.stringify ловит ложные диффы
  // на разном порядке (Vue Router и vue-router/history эмиттят запросы в разных
  // порядках в разных версиях).
  private isQueryEqual(a: Record<string, any>, b: Record<string, any>): boolean {
    const keysA = Object.keys(a).sort();
    const keysB = Object.keys(b).sort();
    if (keysA.length !== keysB.length) return false;
    return keysA.every((k, i) => k === keysB[i] && String(a[k] ?? '') === String(b[k] ?? ''));
  }

  syncQueryParams() {
    const query: Record<string, string> = { ...this.$route.query as any };
    if (this.selectedPlatform) query.platform = String(this.selectedPlatform);
    else delete query.platform;
    if (this.selectedType) query.type = this.selectedType;
    else delete query.type;
    if (this.selectedSuppliers.length) query.suppliers = this.selectedSuppliers.join(',');
    else delete query.suppliers;
    if (this.selectedStatuses.length) query.statuses = this.selectedStatuses.join(',');
    else delete query.statuses;
    if (!this.isQueryEqual(this.$route.query as any, query)) {
      this.$router.replace({ query }).catch(() => undefined);
    }
  }

  persistFiltersToStorage() {
    this.setToStorage('platform', this.selectedPlatform || '');
    this.setToStorage('type', this.selectedType || '');
    this.setToStorage('suppliers', JSON.stringify(this.selectedSuppliers));
    this.setToStorage('statuses', JSON.stringify(this.selectedStatuses));
  }

  // Сравнение по значимым полям — Vuetify может прислать новый объект с тем же
  // содержимым; unconditional assignment вызывает reactivity ping → render → потенциальный
  // повторный emit. Сравниваем перед assign — пропускаем no-op обновления.
  private isTableOptionsEqual(a: DataTableOptions, b: DataTableOptions): boolean {
    return a.page === b.page
      && a.itemsPerPage === b.itemsPerPage
      && a.multiSort === b.multiSort
      && a.sortBy.length === b.sortBy.length
      && a.sortBy.every((v, i) => v === b.sortBy[i])
      && a.sortDesc.length === b.sortDesc.length
      && a.sortDesc.every((v, i) => v === b.sortDesc[i]);
  }

  onTableOptionsChanged(opts: DataTableOptions) {
    if (this.isTableOptionsEqual(this.tableOptions, opts)) return;
    const prevPage = this.tableOptions.page;
    this.tableOptions = opts;
    if (this.isServerPagination && opts.page !== prevPage) {
      this.pageFrom = (opts.page - 1) * PretensionsReport.TABLE_PAGE_SIZE;
      this.scheduleLoadReport();
    }
  }

  // Известные ключи сортировки — соответствуют value из tableHeaders. Любой
  // неизвестный ключ (теоретически возможен из Vuetify) → no-op, без unsafe cast.
  private static readonly SORTABLE_KEYS: ReadonlySet<keyof PretensionReportTableRow> = new Set([
    'id', 'number', 'type', 'platformName', 'supplierLegalName',
    'createdAtIso', '_amount', 'currentStatus',
  ] as Array<keyof PretensionReportTableRow>);

  private static readonly NUMERIC_SORT_KEYS: ReadonlySet<keyof PretensionReportTableRow> = new Set([
    'id', '_amount',
  ] as Array<keyof PretensionReportTableRow>);

  customSort(items: PretensionReportTableRow[], sortBy: string[], sortDesc: boolean[]) {
    if (!sortBy.length) return items;
    const rawKey = sortBy[0];
    if (!PretensionsReport.SORTABLE_KEYS.has(rawKey as keyof PretensionReportTableRow)) {
      return items;
    }
    const key = rawKey as keyof PretensionReportTableRow;
    const desc = !!sortDesc[0];
    const factor = desc ? -1 : 1;
    // null'ы всегда в конец (независимо от direction) — стандартный UX-паттерн
    if (PretensionsReport.NUMERIC_SORT_KEYS.has(key)) {
      return [...items].sort((a, b) => {
        const av = a[key];
        const bv = b[key];
        if (av == null && bv == null) return 0;
        if (av == null) return 1;
        if (bv == null) return -1;
        return factor * (Number(av) - Number(bv));
      });
    }
    return [...items].sort((a, b) => {
      const av = a[key];
      const bv = b[key];
      const aEmpty = av == null || av === '';
      const bEmpty = bv == null || bv === '';
      if (aEmpty && bEmpty) return 0;
      if (aEmpty) return 1;
      if (bEmpty) return -1;
      return factor * String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });
    });
  }

  clearFilters() {
    // Подавляем каскад watcher'ов — иначе 4-5 сбросов в URL/localStorage за один click.
    // Один финальный filterChanged() через $nextTick после всех изменений.
    // DateRange сам сбросит свои даты к дефолту, перехватив 'clear-filters' через $bus,
    // и эмиттит @datesChanged — родитель получит дефолтный диапазон отдельным watcher-фейером,
    // который сейчас тоже подавлен; финальный filterChanged() в $nextTick подхватит всё разом.
    this.suppressWatchers = true;
    this.selectedPlatform = null;
    this.selectedType = null;
    this.selectedSuppliers = [];
    this.selectedStatuses = [];
    this.$bus.$emit('clear-filters');
    this.$nextTick(() => {
      this.suppressWatchers = false;
      this.filterChanged();
    });
  }

  // Снапшот фильтров фиксируется до цикла, чтобы изменение реактивного state
  // в процессе экспорта не смешивало строки из двух выборок и не обходило лимит 50k.
  // includeTotals=true только на первой странице — бэкенду не нужно пересчитывать totals
  // на каждой из ~50 страниц при больших выборках.
  // Дедуп по id защищает от дублирующихся строк, если выборка мутирует на бэке во время экспорта.
  // MAX_ITERATIONS — жёсткий aborts-floor если бэк зациклится из-за нестабильного pagination.total.
  async fetchAllRowsForXlsx(
    baseParams: PretensionReportParams,
  ): Promise<PretensionReportApiRow[] | null> {
    const PAGE = PretensionsReport.XLSX_CHUNK;
    const MAX_ITERATIONS = Math.ceil(PretensionsReport.MAX_XLSX_EXPORT_ROWS / PAGE) + 10;
    const allRows: PretensionReportApiRow[] = [];
    const seen = new Set<number>();
    let pageFrom = 0;
    let iterations = 0;
    /* eslint-disable no-await-in-loop, no-constant-condition */
    while (true) {
      iterations += 1;
      if (iterations > MAX_ITERATIONS) {
        this.$bus.$emit(
          'notification',
          this.t('pretension_report_xlsx_too_many_iterations'),
          'error',
        );
        return null;
      }
      const response = await PretensionController.report({
        ...baseParams,
        pageFrom,
        pageSize: PAGE,
        includeHistory: true,
        includeTotals: pageFrom === 0,
      });
      if (response.result[0]) {
        const outcome = this.classifyHttpError(response);
        this.$bus.$emit('notification', outcome.message, outcome.type);
        return null;
      }
      const payload = response.result[1] as PretensionReportApiResponse | null | undefined;
      const rows = Array.isArray(payload?.data?.rows) ? payload!.data.rows : [];
      const total = payload?.data?.pagination?.total ?? (allRows.length + rows.length);
      if (pageFrom === 0 && total > PretensionsReport.MAX_XLSX_EXPORT_ROWS) {
        this.$bus.$emit(
          'notification',
          this.$t('pretension_report_xlsx_too_many', {
            total,
            limit: PretensionsReport.MAX_XLSX_EXPORT_ROWS,
          }) as string,
          'warning',
        );
        return null;
      }
      rows.forEach((row) => {
        if (!seen.has(row.id)) {
          seen.add(row.id);
          allRows.push(row);
        }
      });
      // Обновляем прогресс — UX-фидбек на длинных выборках.
      this.xlsxProgress = { current: allRows.length, total };
      // Двойной exit-критерий: последняя страница (rows < PAGE) либо набрали весь total.
      if (rows.length < PAGE) break;
      if (allRows.length >= total) break;
      // Хард-стоп от случайного превышения лимита из-за нестабильного total.
      if (allRows.length >= PretensionsReport.MAX_XLSX_EXPORT_ROWS) break;
      pageFrom += PAGE;
    }
    /* eslint-enable no-await-in-loop, no-constant-condition */
    return allRows;
  }

  async downloadXLSX() {
    if (!this.canDownloadXlsx) return;
    // Снапшот фильтров — синхронно, до первого await; см. fetchAllRowsForXlsx.
    // isXlsxLoading отдельный от isDataLoading: экспорт не отменяется при перезагрузке
    // таблицы и наоборот (см. ревью BC3.1 #1, #4).
    const baseParams = this.buildFilterParams();
    this.isXlsxLoading = true;
    // xlsxProgress сбрасывается только в finally; стартовый сброс излишен.
    this.$bus.$emit(
      'notification',
      `${this.$t('pretension_report_xlsx_started')}: ${this.buildFilterSummary(baseParams)}`,
      'info',
    );
    try {
      const allRows = await this.fetchAllRowsForXlsx(baseParams);
      if (!allRows) return;
      const wb = buildPretensionsReportWorkbook(
        allRows,
        (s) => humanizePretensionStatus(s, this.t),
        (t) => this.t(t),
      );
      const fileName = this.buildXlsxFileName();
      XLSX.writeFile(wb, fileName);
      this.$bus.$emit(
        'notification',
        `${this.$t('pretension_report_xlsx_finished')}: ${this.buildFilterSummary(baseParams)}`,
        'success',
      );
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error('downloadXLSX failed', e);
      this.$bus.$emit('notification', 'Не удалось скачать XLSX', 'error');
    } finally {
      this.isXlsxLoading = false;
      this.xlsxProgress = null;
    }
  }

  // Санитизация: убираем символы, недопустимые в именах файлов на Windows/POSIX,
  // схлопываем пробелы и подряд идущие подчёркивания, обрезаем длину сегмента.
  private sanitizeFileNamePart(s: string): string {
    return s
      .replace(/[/\\:*?"<>|]+/g, '_')
      .replace(/\s+/g, '_')
      .replace(/_{2,}/g, '_')
      .replace(/^_|_$/g, '')
      .slice(0, 50);
  }

  buildXlsxFileName(): string {
    const parts: string[] = ['pretensions-report'];
    if (this.dates.length === 2) parts.push(this.dates[0], this.dates[1]);
    if (this.selectedType) parts.push(`type_${this.selectedType}`);
    if (this.selectedPlatform) {
      const p = this.platforms.find((x) => x.id === Number(this.selectedPlatform));
      if (p?.name) parts.push(`platform_${this.sanitizeFileNamePart(p.name)}`);
    }
    if (this.selectedSuppliers.length === 1) {
      const s = this.suppliers.find((x) => x.id === this.selectedSuppliers[0]);
      if (s?.legal_name) parts.push(`supplier_${this.sanitizeFileNamePart(s.legal_name)}`);
    }
    if (this.selectedStatuses.length) {
      parts.push(`statuses_${this.sanitizeFileNamePart(this.selectedStatuses.join('-'))}`);
    }
    // Timestamp в читаемом формате (YYYY-MM-DD-HHmmss) — повторные выгрузки
    // не перезаписывают друг друга и сортируются хронологически в OS Downloads.
    parts.push(new Date().toISOString().slice(0, 19).replace(/[T:]/g, '-'));
    return `${parts.join('-')}.xlsx`;
  }

  // Краткая сводка фильтров для уведомлений о старте/завершении экспорта.
  // Все человекочитаемые куски — через i18n, чтобы en/ru работали единообразно.
  private buildFilterSummary(p: PretensionReportParams): string {
    const bits: string[] = [`${p.dateFrom}…${p.dateTo}`];
    if (p.type) bits.push(this.t(p.type));
    if (p.platformId) {
      const pl = this.platforms.find((x) => x.id === p.platformId);
      if (pl?.name) bits.push(pl.name);
    }
    if (p.supplierIds?.length) {
      bits.push(this.$t('pretension_report_summary_suppliers_count',
        { count: p.supplierIds.length }) as string);
    }
    if (p.statuses?.length) {
      bits.push(this.$t('pretension_report_summary_statuses_count',
        { count: p.statuses.length }) as string);
    }
    return bits.join(', ');
  }

  formatMoney(v: number | null) { return formatMoneyRu(v); }

  humanize(code: string) { return humanizePretensionStatus(code, this.t); }

  // === watchers ===

  @Watch('selectedPlatform')
  onPlatformChanged() {
    if (this.suppressWatchers) return;
    // Если справочник ещё не загружен — сбросить совместимость некому проверять,
    // сразу перегружаем отчёт (selectedSuppliers оставляем как есть).
    if (!this.dictionariesLoaded || this.selectedSuppliers.length === 0) {
      this.filterChanged();
      return;
    }
    // Если платформа сброшена — оставляем поставщиков (бэк сам отфильтрует).
    if (!this.selectedPlatform) {
      this.filterChanged();
      return;
    }
    // Иначе вырезаем только тех поставщиков, что НЕ привязаны к новой платформе.
    const platformId = Number(this.selectedPlatform);
    const validIds = new Set<number>(
      this.suppliers
        .filter((s) => s.PlantsHR?.some((p) => Number(p.id) === platformId))
        .map((s) => Number(s.id)),
    );
    const kept = this.selectedSuppliers.filter((id) => validIds.has(Number(id)));
    if (kept.length !== this.selectedSuppliers.length) {
      // Триггерит onSuppliersChanged → filterChanged. Не дублируем вызов.
      this.selectedSuppliers = kept;
    } else {
      this.filterChanged();
    }
  }

  @Watch('selectedType')
  onTypeChanged() {
    if (this.suppressWatchers) return;
    this.filterChanged();
  }

  @Watch('selectedSuppliers')
  onSuppliersChanged() {
    if (this.suppressWatchers) return;
    this.filterChanged();
  }

  @Watch('selectedStatuses')
  onStatusesChanged() {
    if (this.suppressWatchers) return;
    this.filterChanged();
  }

  @Watch('dates')
  onDatesChanged() {
    if (this.suppressWatchers) return;
    this.filterChanged();
  }
}
